<nav *ngIf="shouldShowNavbar" class="navbar navbar-expand-lg navbar-dark bg-primary">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">MY ITSI</a>
  
    <div class=" " id="navbarNav">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item">
          <button onclick="window.open('https://drive.google.com/drive/folders/1hWmOmvvDxMKF8Fs_lyLJQOr28Ft8Bco9?usp=sharing', '_blank')" type="button" class="btn btn-primary me-2 mb-2 mb-lg-0">Reglas</button>
        </li>
        <li class="nav-item" *ngIf="authService.rol==1">
          <button routerLink="/student" type="button" class="btn btn-primary me-2 mb-2 mb-lg-0">Estudiante</button>
        </li>
        <li class="nav-item" *ngIf="authService.rol==1">
          <button routerLink="/career" type="button" class="btn btn-primary me-2 mb-2 mb-lg-0">Carrera</button>
        </li>
        <li class="nav-item" *ngIf="authService.rol==1">
          <button routerLink="/managment" type="button" class="btn btn-primary me-2 mb-2 mb-lg-0">Gestión</button>
        </li>
        <li class="nav-item" *ngIf="authService.rol==1">
          <button routerLink="/center" type="button" class="btn btn-primary me-2 mb-2 mb-lg-0">Centro</button>
        </li>
        <li class="nav-item" *ngIf="authService.rol==1">
          <button routerLink="/area" type="button" class="btn btn-primary me-2 mb-2 mb-lg-0">Area</button>
        </li>
        <li class="nav-item" *ngIf="authService.rol==1">
          <button routerLink="/areacenter" type="button" class="btn btn-primary me-2 mb-2 mb-lg-0">Asignación Area-Centro</button>
        </li>
        <li class="nav-item" *ngIf="authService.rol==1">
          <button routerLink="/turn" type="button" class="btn btn-primary me-2 mb-2 mb-lg-0">Turnos</button>
        </li>
        <li class="nav-item" *ngIf="authService.rol==1">
          <button routerLink="/inscription" type="button" class="btn btn-primary me-2 mb-2 mb-lg-0">Inscripción</button>
        </li>
        <li class="nav-item" *ngIf="authService.rol==1">
          <button routerLink="/practice" type="button" class="btn btn-primary me-2 mb-2 mb-lg-0">Prácticas</button>
        </li>
        <li class="nav-item">
          <button routerLink="/practiceinscription" type="button" class="btn btn-primary me-2 mb-2 mb-lg-0">Inscripción a Prácticas</button>
        </li>
        <li class="nav-item" *ngIf="authService.rol==1">
          <button routerLink="/signIn" type="button" class="btn btn-primary me-2 mb-2 mb-lg-0">Nuevo Usuario</button>
        </li>
        <li class="nav-item" *ngIf="authService.rol==1">
          <button routerLink="/forgot" type="button" class="btn btn-primary me-2 mb-2 mb-lg-0">Reseteo Contraseña</button>
        </li>
        <li class="nav-item">
          <button (click)="logOut()" type="button" class="btn btn btn-primary me-2 mb-2 mb-lg-0">Salir</button>
        </li>
      </ul>
    </div>
  </div>
</nav>
<div class="me-6"></div>
